import React from "react";
import { useNavigate } from "react-router-dom";
import "../../css/Footer.css";

export const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (e, path) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <footer className="app-footer fixed-bottom">
      <nav className="app-footer__links">
        <a href="/contact-us" onClick={(e) => handleNavigation(e, "/contact-us")}>
          Contact us
        </a>
        <a
          href="/product-resource"
          onClick={(e) => handleNavigation(e, "/product-resource")}
        >
          Product Resources
        </a>
        <a href="/terms-of-service" target="_blank" rel="noreferrer">
          Terms of Service
        </a>
        <a href="/privacy-policy" target="_blank" rel="noreferrer">
          Privacy Policy
        </a>
        <a
          href="https://www.dentsu.com/uk/en/policies/responsible-disclosure-policy"
          target="_blank"
          rel="noreferrer"
        >
          Responsible Disclosure
        </a>
      </nav>

      <div className="app-footer__right">
        <span className="app-footer__copy">
          © Dentsu SmartFeeds <span id="currYear">{new Date().getFullYear()}</span>.
        </span>
        {/* Replace with your logo: <img src={dentsuLogo} alt="dentsu" height="18" /> */}
        <span className="app-footer__brand">dentsu</span>
      </div>
    </footer>
  );
};